var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronLeftBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0159 2.1841C9.4072 1.7928 9.40631 1.1581 9.0139 0.767899L8.94913 0.703484C8.55814 0.314698 7.92624 0.315747 7.53655 0.705831L0.706392 7.54289C0.316204 7.93348 0.316365 8.56637 0.70675 8.95675L7.54289 15.7929C7.93342 16.1834 8.56658 16.1834 8.95711 15.7929L9.01789 15.7321C9.40842 15.3416 9.40842 14.7084 9.01789 14.3179L3.65711 8.95711C3.26658 8.56658 3.26658 7.93342 3.65711 7.54289L9.0159 2.1841Z",
    fill: "#295688"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronLeftBlue);
export default __webpack_public_path__ + "static/media/icon-chevron-left-blue.b15b408ffc46062479754999c7cbba66.svg";
export { ForwardRef as ReactComponent };